<template>
    <header class="w-100 py-3">
        <div class="header-bottom d-flex justify-content-between mb-4">
            <ul>
                <li class="active">
                    <a href="#">
                        <img src="/images/openimagehealth/bars.svg" />
                        <span>Stack Scroll</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/search-plus.svg" />
                        <span>Zoom</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/level.svg" />
                        <span>Levels</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/arrows.svg" />
                        <span>Pan</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/measure-temp.svg" />
                        <span>Length</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/measure-non-target.svg" />
                        <span>Annotate</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/angle-left.svg" />
                        <span>Angle</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/reset.svg" />
                        <span>Reset</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/youtube.svg" />
                        <span>CINE</span>
                    </a>
                </li>
                <li class="dropdown">
                    <a href="" @click.prevent="toggleLayoutSelect()">
                        <img src="/images/openimagehealth/th.svg" />
                        <span>Layout</span>
                    </a>
                    <div class="dropdown-menu custom-dropdown-th" :class="showLayoutSelect?'show-dropdown':''">
                        <table id="table-layout">
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/circle.svg" />
                        <span>Magnify</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/stop.svg" />
                        <span>ROI Window</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/dot-circle.svg" />
                        <span>Probe</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/circle-o.svg" />
                        <span>Ellipse</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/squere-o.svg" />
                        <span>Rectangle</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/adjust.svg" />
                        <span>Invert</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/rotate-right.svg" />
                        <span>Rotate Right</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/ellipse-h.svg" />
                        <span>Flip H</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/ellipse-v.svg" />
                        <span>Flip V</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/trash.svg" />
                        <span>Clear</span>
                    </a>
                </li>

            </ul>
        </div>

        <div class="header-bottom d-flex justify-content-between">
            <ul>
                <li>
                    <a href="" @click.prevent="$emit('toggleLeftSideBar')">
                        <div class="roundedButton">
                            <img src="/images/openimagehealth/th-large.svg" />
                        </div>
                        <span>Series</span>
                    </a>
                </li>
                <li>
                    <a href="" @click.prevent="$emit('toggleRightSideBar')">
                        <div class="roundedButton">
                            <img src="/images/openimagehealth/list.svg" />
                        </div>
                        <span>Measurements</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/measure-target.svg" />
                        <span>Bidirectional</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/eraser.svg" />
                        <span>Eraser</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="/images/openimagehealth/create-screen-capture.svg" />
                        <span>Download</span>
                    </a>
                </li>

            </ul>
        </div>

    </header>
</template>

<script>
    export default {
        data() {
            return {
                showLayoutSelect: false
            }
        },
        methods: {
            toggleLayoutSelect() {
                this.showLayoutSelect = !this.showLayoutSelect;
            }
        }
    }
</script>